import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'kig-group-c4769',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || 'BIofn9UxVP-ceVvhA63wIpzI-GcVOkhKNKdJg1GiOekQBOPlzigHFENt8F56tnU838N_tSHwP4QMscfBfPogOYM';

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

function isConfigValid(): boolean {
  return !!(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.messagingSenderId && firebaseConfig.appId);
}

function getApp(): FirebaseApp | null {
  if (!isConfigValid()) return null;
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
}

function getMessagingInstance(): Messaging | null {
  if (!getApp()) return null;
  if (!messaging && typeof window !== 'undefined') {
    try {
      messaging = getMessaging(app!);
    } catch (e) {
      console.warn('Firebase Messaging init failed:', e);
    }
  }
  return messaging;
}

export async function getFCMToken(): Promise<string | null> {
  const msg = getMessagingInstance();
  if (!msg || !VAPID_KEY) return null;
  try {
    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      registration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/firebase-messaging-sw.js`);
      await registration.update();
    }
    const token = await getToken(msg, { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration });
    return token || null;
  } catch (e) {
    console.warn('FCM getToken failed:', e);
    return null;
  }
}

export function isNotificationSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window && 'serviceWorker' in navigator;
}

/** Register this device's FCM token with the backend (call after login with auth header). */
export async function registerFCMTokenWithBackend(getAuthHeader: () => string, apiRegisterUrl: string): Promise<boolean> {
  if (!isNotificationSupported()) return false;
  try {
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') return false;
    const token = await getFCMToken();
    if (!token) return false;
    const res = await fetch(apiRegisterUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: getAuthHeader() },
      body: JSON.stringify({ token }),
    });
    return res.ok;
  } catch (e) {
    console.warn('FCM register with backend failed:', e);
    return false;
  }
}
